/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PhasesDropdown_phases$ref: FragmentReference;
declare export opaque type PhasesDropdown_phases$fragmentType: PhasesDropdown_phases$ref;
export type PhasesDropdown_phases = $ReadOnlyArray<{|
  +node: ?{|
    +name: ?string,
    +id: string,
  |},
  +$refType: PhasesDropdown_phases$ref,
|}>;
export type PhasesDropdown_phases$data = PhasesDropdown_phases;
export type PhasesDropdown_phases$key = $ReadOnlyArray<{
  +$data?: PhasesDropdown_phases$data,
  +$fragmentRefs: PhasesDropdown_phases$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PhasesDropdown_phases",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhaseType",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhaseTypeEdge"
};
// prettier-ignore
(node/*: any*/).hash = 'e943662da8e1da46bac775f3bf2a9449';

module.exports = node;
